<template>
	<div class="searchData">
		<el-row class="topsercah">
			<el-form :inline="true" label-position="right" class="el-form-class" :model="listQuery" size="small">
				<slot name="defaultQuery"></slot>
				<el-form-item class="mb15" v-for="(item, index) in searchlist" :key="index"
					:style="item.isValid == 1 ? 'margin-right:10px' : 'margin-right:0px'">
					<template v-if="item.isValid == 1">
						<span slot="label">{{ item.cnName }}</span>
						<!-- 日期时间范围选择 -->
						<el-date-picker
							v-if="item.inputType === 'datetimerange' || item.inputType == 'date' || item.inputType == 'datetime' || item.inputType == 'date'"
							style="width:350px;" v-model="datetimerangeObj[item.name]" type="daterange"
							range-separator="~" :default-time="['00:00:00', '23:59:59']" :start-placeholder="Language('开始日期')"
							:end-placeholder="Language('结束日期')" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						<!-- 选择框 -->
						<SelectList style="width:216px"
							v-else-if="item.inputType === 'select' || item.inputType == 'personnelSelect' || item.inputType === 'radio' || item.inputType === 'checkbox' || item.name == 'labMsg'"
							:placeholderLoad="item.cnName" :dataMultiple="item.selectType" :ref="item.name"
							:dataOrigin="item.dataOrigin" :inputType="item.inputType" :fieldName="item.name"
							@changeOrgFn="changeOrgFn" :filterData="filterData[item.dataOrigin]"></SelectList>
						<!-- 级联选择 -->
						<CascaderList style="width:216px;" :checkStrictly="item.cascadeType == 1 ? true : false"
							v-else-if="item.inputType === 'cascader'" :placeholderLoad="item.cnName" :ref="item.name"
							:dataOrigin="item.dataOrigin"></CascaderList>
						<!-- 多行文本框 -->
						<!-- <el-input style="width:216px;" v-else-if="item.inputType === 'textarea'" type="textarea"
							v-model="listQuery[item.name]" :placeholder="'请输入' + item.cnName"></el-input> -->
						<!-- 数字框 -->
						<el-input-number style="width:120px;" v-model="listQuery[item.name]"
							v-else-if="item.inputType === 'number'" controls-position="right"></el-input-number>
						<!-- 输入框 -->
						<el-input style="width:216px;" v-else v-model="listQuery[item.name]" clearable
							:placeholder="'请输入' + item.cnName"></el-input>
					</template>
				</el-form-item>
				<el-form-item label-width="15px">
					<el-button type="primary" size="small" @click="searchFn(1)" class="queryBtn">{{ Language('查询') }}</el-button>
					<el-button type="info" plain size="small" @click="resetFn" class="queryBtn">{{Language('重置')}}</el-button>
				</el-form-item>
				<el-button type="text" size="small" @click="setTable(true)">{{Language('自定义条件')}}</el-button>
			</el-form>
		</el-row>
		<el-dialog :title="Language('查询设置')" :visible="visibleAllTitle" :modal-append-to-body="false" :close-on-press-escape="false"
			:close-on-click-modal="false" top="10vh" width="600px" class="abow_dialog" @close="setTable(false)">
			<SearchSet @closedialogVosible="setTable" @getNewData="getNewData" :visibleAllTitle="visibleAllTitle"
				:configType="configType" :formValue="formValue" :partType="partType"></SearchSet>
		</el-dialog>
	</div>
</template>

<script>
import { getDictMap } from '@/http/BaseData.js'
import SearchSet from './SearchSet.vue'
import SelectList from './SelectList.vue'
import CascaderList from './CascaderList.vue'

export default {
	components: { SearchSet, SelectList, CascaderList },
	props: {
		searchlist: Array,
		configType: Number, //表类型，1.客户 2.客户公司 3.工单
		formValue: Number, //1客户 2客户公司 3工单 4未解决工单 5督办工单
		partType: String, //search: 搜索字段  column:列表显示字段 form：工单表单显示字段
	},
	data() {
		return {
			vdnId: '',
			listQuery: {},
			selectOptionData: {},
			datetimerangeObj: {},
			visibleAllTitle: false,
			filterData: [], //下拉数据集
		}
	},
	watch: {
		searchlist: {
			deep: true,
			handler: function (newV, oldV) {
				this.getDictyFilterData()
			},
		},
	},
	mounted() {
		this.vdnId = JSON.parse(LocalStorage.getItem("obj")).vdnId
	},
	created() {

	},
	methods: {
		//切换部门
		changeOrgFn(data) {
			if (this.$refs['userId']) {
				this.$refs['userId'][0].fetchUserListFn(data)
			}
		},
		//统一获取下拉框数据
		getDictyFilterData() {
			let paramsSelectData = this.searchlist.filter(item => {
				if (item.dataOrigin && item.dataOrigin != '0') return item
			})
			let selectParams = paramsSelectData.map(item => { return item.dataOrigin })
			let selectParamsony = Array.from(new Set(selectParams))//去重
			let params = {
				dictTypeCodeList: selectParamsony,
				vdnId: this.vdnId
			}
			getDictMap(params).then((res) => {
				if (res && res.retCode == 1) {
					this.filterData = res.data
				}
			})
		},
		searchFn(page) {
			// queryData
			let listQuery = this.listQuery
			let refsObj = this.$refs
			let datetimerangeObj = this.datetimerangeObj
			let queryData = []
			if (listQuery) {
				for (let fild in listQuery) {
					if (listQuery[fild]) {
						if (listQuery[fild] instanceof Date) queryData.push({ fieldName: fild, value: this.renderTime(listQuery[fild]) })
						else queryData.push({ fieldName: fild, value: listQuery[fild] })
					}
				}
			}
			if (refsObj) {
				for (let fild in refsObj) {
					if (refsObj[fild].length) {
						let values = refsObj[fild][0].values
						if (fild == 'groupId' || fild == 'labMsg') {
							if (fild, values && values.length) queryData.push({ fieldName: fild, value: values[values.length - 1] })
						} else {
							if (values) {
								if (values instanceof Array) queryData.push({ fieldName: fild, value: values.join(',') })
								else queryData.push({ fieldName: fild, value: values })
							}
						}
					}
				}
			}
			if (datetimerangeObj) {
				for (let fild in datetimerangeObj) {
					if (datetimerangeObj[fild]) {
						queryData.push({
							fieldName: fild, value: datetimerangeObj[fild][0] + '~' + datetimerangeObj[fild][1]
						})
					}
				}
			}
			this.$emit('fetchTableListFn', queryData, page)
		},
		resetFn() {
			this.datetimerangeObj = {}
			for (let fild in this.listQuery) {
				this.listQuery[fild] = null
			}
			this.searchlist.forEach(row => {
				if (row.isValid == 1) {
					if (row.inputType === 'select' || row.inputType === 'cascader' || row.name === 'labMsg') {
						this.$refs[row.name][0].values = null
					}
				}
			})
			this.searchFn(1)
		},
		//表格设置
		setTable(status) {
			this.visibleAllTitle = status
		},
		//获取查询新配置
		getNewData(data) {
			this.$emit('fetchFormQueryList')
		},
	},
}
</script>
<style scoped lang="scss">
/deep/.el-form--inline .el-form-item__label {
	// width: 80px;
	float: none;
	display: inline-block;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap
}

/deep/.el-form .el-form-item {
	margin-bottom: 18px !important;
}

.dsadsasdeac /deep/.el-collapse-item__header {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	height: 48px;
	line-height: 48px;
	background: #f7f8fa !important;
	color: #303133;
	cursor: pointer;
	border-bottom: 0px solid #EBEEF5;
	font-size: 13px;
	font-weight: 500;
	-webkit-transition: border-bottom-color .3s;
	transition: border-bottom-color .3s;
	outline: 0;
}

.caret-top {
	background: #ffffff;
	width: 35px;
	height: 35px;
	text-align: center;
	line-height: 35px;
	border-radius: 48px;
	cursor: pointer;
}

.setSearch {
	position: absolute;
	right: 0px;
	top: -20px;
	font-size: 20px;
}

.abow_dialog {
	/deep/.el-dialog__body {
		overflow: auto;
	}
}</style>



// WEBPACK FOOTER //
// SearchGet.vue?dec29460